import React, {useCallback, useEffect, useState} from "react";
import {apolloClientReports} from "../../../GraphQL/config";
import {QUERY_GET_NUMBER_OF_LEAK_ALERTS} from "../../../GraphQL/ReportGenerator/queries";
import {
    buildCategoriesData,
    getCategoriesByResolution,
    getEndDate,
    getResolutionName,
    gqlDateFormat,
    pushCsvDates,
    setCsvHeaders
} from "../Utils/utils";
import {
    EXCEL_TITLE_NUMBER_OF_LEAKS,
    HIGH_FLOW,
    HIGH_FLOW_LEAK,
    LOW_FLOW,
    LOW_FLOW_LEAK,
    MODERATE_FLOW,
    MODERATE_FLOW_LEAK
} from "../../../Constants/constants";
import {ProjectColors} from "../../../Enums/Core/projectColors";
import {Spinner} from "react-bootstrap";
import StackedBarChart from "../../StackedBarChart/StackedBarChart";
import ExportToExcelButton from "../ExportToExcelButton/ExportToExcelButton";

export default function NumberOfLeakAlertsChartHighResolution(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [responseData, setResponseData] = useState([]);
    const [chartData, setChartData] = useState();
    const [categories, setCategories] = useState([]);
    const [csvData, setCsvData] = useState([]);

    console.log(props.selectedDate)
    console.log(props.modalResulotion)

    const getNumberOfLeakAlertsFromDB = () => {
         apolloClientReports.query({ query: QUERY_GET_NUMBER_OF_LEAK_ALERTS, variables: {
                resolution: getResolutionName(props?.modalResulotion-1),
                from: gqlDateFormat(props?.selectedDate),
                to: gqlDateFormat(getEndDate(props?.selectedDate, props?.modalResulotion-1))
            } }).then(res => {
                let response = res?.data?.leakAlertsHistogram;
                if (!response) {
                    console.error(`Data from NumberOfLeakAlerts HighResolution is empty`);
                } else {
                    setResponseData(response?.data?.slice().sort((a, b) => (a.from < b.from) ? -1 : ((a.from > b.from) ? 1 : 0)));
                }
        })
    }

    const getLeaksNumber = (type) => {
        let leakNumbers = [];
        responseData.forEach((major) => {
            major.severity.map((leak) => {
                if (leak.label === type) {
                    leakNumbers.push(leak.value);
                }
            })
        })
        return leakNumbers;
    }


    const buildCsvData = (responseData) => {
        let csvData = [];
        let headers = setCsvHeaders(props.modalResulotion-1);
        headers.push('Total alerts', 'High', 'Moderate', 'Low');
        csvData.push(headers);

        responseData.forEach((entity, index) => {
            let row = [];
            let leakCounts = entity.severity.map((severityElement) => severityElement.value);
            row.push(index+1);
            row = pushCsvDates(props.modalResulotion-1, entity.date, row);
            row.push(leakCounts.reduce((a, b) => a + b, 0), leakCounts[2], leakCounts[1], leakCounts[0]);
            csvData.push(row);
        });

        return csvData;
    }

    useEffect(() => {
        setIsLoading(true);
        getNumberOfLeakAlertsFromDB();
    }, [props]);

    useEffect(() => {
        setCategories(buildCategoriesData(responseData,props.modalResulotion-1));
        forceUpdate();
    }, [responseData])

    useEffect(() => {
        setChartData([{
            name: HIGH_FLOW,
            data: getLeaksNumber(HIGH_FLOW_LEAK),
            color: ProjectColors.DarkRed
        }, {
            name: MODERATE_FLOW,
            data: getLeaksNumber(MODERATE_FLOW_LEAK),
            color: ProjectColors.Red
        }, {
            name: LOW_FLOW,
            data: getLeaksNumber(LOW_FLOW_LEAK),
            color: ProjectColors.Orange
        }]);
    }, [categories]);

    useEffect(() => {
        setCsvData(buildCsvData(responseData));
        setIsLoading(false);
        forceUpdate();
    }, [chartData]);

    const [, setUpdateState] = useState();
    const forceUpdate = useCallback(() => setUpdateState({}), []);

    return (
        <>
            { isLoading && <Spinner animation="border" variant="primary"/> }
            { !isLoading &&
                <>
                    <div className="float-right">
                        <ExportToExcelButton
                            csvData={csvData || null}
                            title={EXCEL_TITLE_NUMBER_OF_LEAKS}/>
                    </div>
                    <br/>
                    <br/>
                    <StackedBarChart
                        categories={categories}
                        data={chartData}
                    />
                </>
            }
        </>
    )
}